import api from './api';
import { Document, PaginatedResponse } from '../types';

export interface DocumentFilters {
  page?: number;
  limit?: number;
  search?: string;
  category?: string;
}

const documentsService = {
  getList: async (filters: DocumentFilters = {}): Promise<PaginatedResponse<Document>> => {
    const params = new URLSearchParams();
    if (filters.page) params.append('page', String(filters.page));
    if (filters.limit) params.append('limit', String(filters.limit));
    if (filters.search) params.append('search', filters.search);
    if (filters.category) params.append('category', filters.category);
    const response = await api.get(`/documents?${params.toString()}`);
    return response.data;
  },

  getById: async (id: number): Promise<Document> => {
    const response = await api.get(`/documents/${id}`);
    return response.data.data;
  },

  create: async (data: Omit<Document, 'id' | 'createdAt' | 'updatedAt'>): Promise<Document> => {
    const response = await api.post('/documents', data);
    return response.data.data;
  },

  update: async (id: number, data: Partial<Document>): Promise<Document> => {
    const response = await api.put(`/documents/${id}`, data);
    return response.data.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(`/documents/${id}`);
  },
};

export default documentsService;